import { updateBankSource } from 'commons/service/bank/salesData'
import { BankSourceCreateFormValue, BankSourceCreateResponse } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useBankSourceUpdate: WriteHook<BankSourceCreateFormValue, BankSourceCreateResponse> = (opts) =>
  useMutationManager<BankSourceCreateFormValue, BankSourceCreateResponse>(updateBankSource, opts)
